import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import {ChallengeSummary} from '@/services/participant-service';

export interface CodeState {
    questionNumber: number;
    code: string;
    templateCode: string;
    problemDescription: string;
    endTime: Date | null;
    submitted: boolean;
    sample: boolean;
    finished: boolean;
}

@Module({
    namespaced: true,
})
export default class ParticipantVuexModule extends VuexModule {

    protected _codeState: CodeState = null!;
    protected _challengeSummary: ChallengeSummary = null!;

    @Action
    public saveChallengeSummary(challengeSummary: ChallengeSummary): void {
        this.context.commit('internalSaveChallengeSummary', challengeSummary);
    }

    @Mutation
    protected internalSaveChallengeSummary(challengeSummary: ChallengeSummary): void {
        this._challengeSummary = challengeSummary;
    }

    public get challengeSummary() {
        return this._challengeSummary;
    }

    @Action
    public saveCodeState(codeState: CodeState): void {
        this.context.commit('internalSaveCodeState', codeState);
    }

    @Mutation
    protected internalSaveCodeState(codeState: CodeState): void {
        this._codeState = codeState;
    }

    public get codeState() {
        return this._codeState;
    }

}
